// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__3yCTa","hideOnTablet":"styles_hideOnTablet__3pwXL","hideOnMobile":"styles_hideOnMobile__1xeta","cards":"styles_cards__3MHcA"};